const initState = {
  claimants: [],
  policy: [],
  claim: [],
  isLoading: false,
  pageType: "",
  pageMode: "", //claim or fr or policy
  args: [],
  visibleModalIndex: "",//to identify which modal is opened/visible.
  // pipBills:[]
};
export default initState;
